export default "__VITE_ASSET__B5D_nDNE__"